<template>
  <div :class="['list', css, `list__${children.length}`]">
    <paginate
      ref="paginator"
      name="children"
      :list="children"
      :per="itemsPerPage"
      tag="div"
    >
      <transition-group
        v-bind:css="false"
        ref="list"
        name="list"
        tag="div"
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
        appear
      >
        <component
          :is="item.type"
          v-for="(item, i) in paginated('children')"
          :key="item.title + i"
          v-bind="item"
        >
        </component>
      </transition-group>
    </paginate>
    <transition name="slide-up" appear>
      <div
        class="pager py-2xl"
        v-if="!!children.length && children.length > itemsPerPage"
      >
        <paginate-links
          id="pager"
          ref="pager"
          for="children"
          :limit="4"
          :show-step-links="true"
          @change="onLangsPageChange"
          :step-links="{ next: localize('next'), prev: localize('prev') }"
        ></paginate-links>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  props: {
    children: {
      type: Array,
      required: true
    },
    css: {
      type: String,
      default: ""
    },
    content: String
  },
  data() {
    return {
      itemsPerPage: 8,
      paginate: ["children"]
    };
  },
  methods: {
    beforeEnter: function(el) {
      el.style.opacity = 0;
      el.style.transform = "translateY(80%)";
    },
    enter: function(el, done) {
      let lapse = 180,
        delay = el.dataset.index * lapse;
      setTimeout(function() {
        el.animate(
          {
            opacity: [0, 1],
            transform: ["translateY(80%)", "translateY(0)"],
            easing: "cubic-bezier(0.175, 0.885, 0.32, 1.275)"
          },
          { duration: 600, fill: "forwards" }
        ).onfinish = function() {
          done();
        };
      }, delay);
    },
    leave: function(el, done) {
      el.style.opacity = 0;
      el.style.transform = "translateY(120%)";
      done();
    },
    onLangsPageChange() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }
};
</script>
<style lang="stylus">
.list
  .content-block:not(:last-child)
    border-bottom 1px solid rgba(blue_3, 0.5)
    +below(600px)
      border-bottom none

.list.grid
  _flex(row, wrap, flex-start, space-between)
  pad('2xl', x)
  & > *
    flex 0 0 33.33%
    border 10px solid #fff
    // cursor pointer
    background-position 90% 90% !important
    background-size auto 57% !important
  &.list__5 > *
  &.list__7 > *
    &:nth-child(1)
    &:nth-child(2)
      background-size auto 75% !important
      flex 0 0 50%
  &.list__7 > *
    &:nth-child(6)
    &:nth-child(7)
      background-size auto 75% !important
      flex 0 0 50%

    // background-color blue
  +below(1100px)
    _flex(column, wrap, flex-start, space-between)
    & > *
      flex 0 0 100%
      border none
      width 100%
      height 30vh
      background-size auto 95% !important
      background-position 70% 125% !important
      pad('2xl', y)
      marg('l', bottom)
      overflow hidden
</style>
